"use strict";

var React = require('react');

var _ = require('lodash');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var Button = require('../button');

function makeButton(section, sectionIndex, option, optionIndex) {
  return /*#__PURE__*/React.createElement(Button, {
    key: option + optionIndex,
    className: "btn-thumbnail",
    disabled: option.disabled,
    onClick: option.onClick
  }, option.illustration);
}

function makeThumbnail(section, sectionIndex) {
  return React.createElement.apply(this, ['div', {
    className: 'thumbnail-buttons-section',
    key: 'section' + sectionIndex
  }, _.map(section, makeButton.bind(this, section, sectionIndex))]);
}

function ThumbnailButtonGroup(props) {
  return React.createElement.apply(this, ['div', {
    className: props.getClassName('control-thumbnail-button-group'),
    'data-aid': props.automationId,
    'data-hook': props.dataHook,
    'data-max-items-per-row': props.maxThumbsPerRow
  }, _.map(props.numOfThumbsThatForceBreak ? _.chunk(props.options, props.numOfThumbsThatForceBreak) : [props.options], makeThumbnail.bind(this))]);
}

ThumbnailButtonGroup.displayName = displayNames.THUMBNAIL_BUTTON_GROUP;
ThumbnailButtonGroup.propTypes = {
  /** List of thumbnails object to display */
  options: PropTypes.arrayOf(PropTypes.shape({
    illustration: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  })).isRequired,

  /** Maximum number of thumbnails to display per row */
  maxThumbsPerRow: PropTypes.number.isRequired,
  numOfThumbsThatForceBreak: PropTypes.number
};
module.exports = compose(ThumbnailButtonGroup);